import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    inner: {},
    header: {
      gap: 12,
      [theme.fn.smallerThan('sm')]: {
        padding: `${rem(24)} ${rem(24)} 0`,
      },
      [theme.fn.largerThan('sm')]: {
        alignItems: 'center',
        gap: 16,
        padding: 40,
      },
    },
  }
})
